import { useQuery } from "@apollo/client/react"; import React, { useState, useEffect, useMemo } from "react";

import { Grid, Button } from '@mui/material';
import { RenderInputByTypeMobile } from "../../../../components/formGroupGenerator/RenderInputByTypeMobile";
import { getStringQueryCombosRI } from '../../../../data/graphQL/queries/ResumenIngreso/getAllCombosRI';
import { adaptCombosRIArray } from '../../../../adapters/resumenIngreso/combosRIAdapter';
import './stepCuidadosPaliativos.scss';
import TratamientoInput from "./components/TratamientoInput";
import { IndicacionDetalladaInput } from "./components/IndicacionDetalladaInput";

export const StepCuidadosPaliativos3 = ({
  selectedPrograms,
  setDataSubmissionCallback,
  updateFormData,
  esAdulto,
  fullFormDataRI,
  pantallas,
  idDatosGeneralesRI,
  edit
}) => {
  const [cuidadosPaliativos, setCuidadosPaliativos] = useState(fullFormDataRI?.cuidadosPaliativos3 ?? {});
  const [combosRI, setCombosRI] = useState();
  const [childrenAction, setChildrenAction] = useState(null);
  const [childrenActionIndicacion, setChildrenActionIndicacion] = useState(null);

  const idPantallaRI = useMemo(() => {
    return pantallas.find((p) => p.displayName.includes('CP'))?.id;
  }, [pantallas]);

  const handleSubmit = () => {
    updateFormData('cuidadosPaliativos3', cuidadosPaliativos, validatedinputsGroups.flatMap((x) => x.inputs));
  };

  const handleChange = (name, value) => {
    setCuidadosPaliativos((prevDatos) => ({
      ...prevDatos,
      [name]: value
    }));
  };

  const getOptionsByName = (fieldName) => {
    const combos = {
      'idComboRIValorPoseeInfDiagnostica': combosRI?.idComboRIValorPoseeInfDiagnostica.map((e) => { return { label: e.displayName, value: e.id }; }),
      'idComboRIValorPoseeInfPronostico': combosRI?.idComboRIValorPoseeInfPronostico.map((e) => { return { label: e.displayName, value: e.id }; }),
      'idComboRIValorPoseeInfEnfermedad': combosRI?.idComboRIValorPoseeInfEnfermedad.map((e) => { return { label: e.displayName, value: e.id }; }),
      'idComboRIValorNombraPalabraCancer': combosRI?.idComboRIValorNombraPalabraCancer.map((e) => { return { label: e.displayName, value: e.id }; }),
      'idComboRIValorCercoDeSilencio': combosRI?.idComboRIValorCercoDeSilencio.map((e) => { return { label: e.displayName, value: e.id }; }),
      'idComboRIValorTrastornoAdaptacion': combosRI?.idComboRIValorTrastornoAdaptacion.map((e) => { return { label: e.displayName, value: e.id }; })
    };

    return combos[fieldName] || [];
  };

  const inputCombos = inputsGroups.flatMap((inputgroup) => {
    return inputgroup.inputs.filter((input) => !!input.comboName);
  });

  const { data: combosData } = useQuery(getStringQueryCombosRI(inputCombos));

  useEffect(() => {
    if (!combosData) return;

    setCombosRI(adaptCombosRIArray(combosData));
  }, [combosData]);

  const validatedinputsGroups = useMemo(() => {
    const updatedRequired = inputsGroups.map((group) => ({
      ...group,
      inputs: group.inputs.map((prevInput) => {
        const input = {
          ...prevInput,
          options: prevInput.type == "select" || prevInput.type.includes("multiple") ? getOptionsByName(prevInput.name) : []
        };

        switch (input.name) {
          case 'viveSolo':
            if (!esAdulto) handleChange(input.name, false);
            return {
              ...input,
              required: esAdulto,
              hidden: !esAdulto
            };
          default:
            return input;
        }
      })
    }));

    return updatedRequired;
  }, [selectedPrograms, esAdulto, combosRI]);

  useEffect(() => {
    setDataSubmissionCallback(handleSubmit);
  }, [cuidadosPaliativos, setDataSubmissionCallback, validatedinputsGroups]);


  return (
    <div>
      {validatedinputsGroups.map((group) =>
        <div className='step-form-section-container' key={group.groupName}>
          {group.groupName === 'Tratamiento Actual' &&
            <label className={`step-form-section-title ${childrenAction ? 'with-children-action' : ''}`}>
              {group.groupName} {Boolean(childrenAction) && childrenAction}
            </label>}
          {group.groupName === 'Indicación' &&
            <label className={`step-form-section-title ${childrenActionIndicacion ? 'with-children-action' : ''}`}>
              {group.groupName} {Boolean(childrenActionIndicacion) && childrenActionIndicacion}
            </label>}
          {group.groupName !== 'Tratamiento Actual' && group.groupName !== 'Indicación' &&
            <label className='step-form-section-title'>{group.groupName || ''}</label>}
          <Grid
            container>
            {group.inputs.filter((x) => !x.hidden).map((input) => {
              return (
                <React.Fragment key={`${group.groupName}-${input.name}`}>
                  {input.name === "cPMedicacionDosificacionRI" ?
                    <TratamientoInput
                      handleChange={handleChange}
                      prevTratamientos={cuidadosPaliativos[input.name]}
                      setChildrenAction={setChildrenAction} /> :


                    input.name === "indicaciones" ?
                      <IndicacionDetalladaInput
                        idDatosGeneralesRI={idDatosGeneralesRI}
                        idPantallaRI={idPantallaRI}
                        setChildrenAction={setChildrenActionIndicacion}
                        edit={edit} /> :


                      <RenderInputByTypeMobile
                        key={`${group.groupName}-${input.name}`}
                        grided
                        row
                        handleChange={handleChange}
                        input={input}
                        value={cuidadosPaliativos[input.name]} />
                  }
                </React.Fragment>);

            })}
          </Grid>
        </div>
      )
      }
    </div>);

};

export default StepCuidadosPaliativos3;

const inputsGroups = [
  {
    groupName: 'Situación socio-familiar',
    inputs: [
      {
        displayName: '¿Vive solo?',
        name: 'viveSolo',
        type: 'boolean',
        required: true
      },
      {
        displayName: '¿Tiene cuidadores contratados?',
        name: 'cuidadoresContratados',
        type: 'boolean',
        required: true
      },
      {
        displayName: '¿Existe claudicación familiar?',
        name: 'claudicacionFamiliar',
        type: 'boolean',
        required: true
      },
      {
        displayName: 'Otros datos socioeconómicos o familiares',
        name: 'datosSocioEcoFamiliares',
        type: 'long_string',
        required: false
      }]

  },
  {
    groupName: 'Situación de información del paciente y la familia',
    inputs: [
      {
        displayName: '¿Posee información diagnóstica?',
        comboName: 'Rta. Simple',
        name: 'idComboRIValorPoseeInfDiagnostica',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: '¿Posee información sobre el pronóstico?',
        comboName: 'Rta. Simple',
        name: 'idComboRIValorPoseeInfPronostico',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: '¿Pide información sobre la enfermedad?',
        comboName: 'Rta. Simple',
        name: 'idComboRIValorPoseeInfEnfermedad',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: '¿Nombra la palabra cáncer?',
        comboName: 'Rta. Simple',
        name: 'idComboRIValorNombraPalabraCancer',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: '¿Hay cerco de silencio?',
        comboName: 'Rta. Simple',
        name: 'idComboRIValorCercoDeSilencio',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: '¿Existe trastorno de adaptación?',
        comboName: 'Rta. Simple',
        name: 'idComboRIValorTrastornoAdaptacion',
        type: 'multiple_boolean',
        required: true
      },
      {
        displayName: 'Otros datos de información relevantes',
        name: 'otrosDatosInformacion',
        type: 'long_string',
        required: false
      }]

  },
  {
    groupName: 'Tratamiento Actual',
    inputs: [
      {
        displayName: 'Tratamiento Actual',
        name: 'cPMedicacionDosificacionRI',
        type: 'array'
      }]

  },
  {
    groupName: 'Problemas principales a tratar',
    inputs: [
      {
        displayName: 'Físicos',
        name: 'problemaFisico',
        type: 'string',
        required: false
      },
      {
        displayName: 'Psicológicos',
        name: 'problemaPsicologico',
        type: 'string',
        required: false
      },
      {
        displayName: 'Sociales',
        name: 'problemaSocial',
        type: 'string',
        required: false
      },
      {
        displayName: 'Espirituales',
        name: 'problemaEspiritual',
        type: 'string',
        required: false
      }]

  },
  {
    groupName: 'Indicación',
    inputs: [
      {
        displayName: 'Indicación',
        name: 'indicaciones',
        type: 'array'
      }]

  },
  {
    groupName: '',
    inputs: [
      {
        displayName: 'Requerimientos',
        name: 'otrasIndicaciones',
        type: 'long_string',
        required: true
      }]

  }];